export const BASIC_TOKEN = 'CHIZ';
export const GITHUB = 'https://github.com/JasonGhostDev/chiz-new-farm';
